import React, { useContext } from 'react'
import { useFormik } from 'formik'
import { CartContext } from '../../context/CartContext';
import useUserCart from '../../hooks/useUserCart';
import toast from 'react-hot-toast';
import { UserContext } from '../../context/userAuth';

export default function Payment() {


    const { payment } = useContext(CartContext);
    const { data } = useUserCart();

    const initialValues = {
        details: '',
        phone: '',
        city: '',
    }

    const handlePayment = async (shippingAddress) => {
        try {
            const { status, session } = await payment(data?.data._id, { shippingAddress })
            if (status === 'success') {
                window.location = session.url
            }
        } catch (error) {
            toast.error(error);
        }
    }

    const formik = useFormik({
        initialValues,
        onSubmit: (data) => handlePayment(data)
    })

    return <>
        <div className="w-75 m-auto p-3">
            <h3 className='my-3 text-center text-main'>Payment Form</h3>
            <form onSubmit={formik.handleSubmit}>
                <label htmlFor="details">Details</label>
                <input type="details" name="details" id="details" className='form-control my-2' />
                <label htmlFor="city">City</label>
                <input type="city" name="city" id="city" className='form-control my-2' />
                <label htmlFor="phone">Phone</label>
                <input type="phone" name="phone" id="phone" className='form-control my-2' onChange={formik.handleChange} onBlur={formik.handleBlur} />
                <button type='submit' className='bg-main btn text-white mt-2'>Pay!</button>
            </form>
        </div >
    </>
}